import { accordions } from './_accordion.js';
export let productsTool = {
	isMobile: false,
	init: function( block ){
		accordions.init();
		productsTool.setTitleHeight( block );
		productsTool.setMainImage();
		setTimeout(function(){
			productsTool.setTitleHeight( block );
		}, 200);
	},
	setTitleHeight: function(el){
		//resize時にも発動させる 2025.10.06
		let $title = el.querySelector(".product__title .product__title_cols");
		
		let titleH = $title.clientHeight;
		document.documentElement.style.setProperty("--product-title-height", `${titleH}px`);
		if( titleH >= 105 ){
			if( !$title.classList.contains("row1") ){
				$title.classList.remove("row0");
				$title.classList.add("row1");
			}
		}else{
			if( !$title.classList.contains("row0") ){
				$title.classList.remove("row1");
				$title.classList.add("row0");
			}
		}
	},
	setMainImage: function(){
		//console.log("setMainImage");
		if (window.__bindMainImageSyncOnce) return;
		window.__bindMainImageSyncOnce = true;
		//let $mediaScrollBlock = document.querySelector(".product__media-wrapper .product_scroll_wrap");
		// Dawn/Rise系 pubsub を購読（product-info.js 内で publish される）
		subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
			const { sectionId, variant, html } = data;
			const mainImg = document.getElementById(`MainVariantImage-${sectionId}`);
			//console.log("variant Change", mainImg, variant)
			if (!mainImg || !variant) return;
			
			let parsedDoc = html;
			if (typeof html === 'string') {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				parsedDoc = doc;
			}
			const $mediaScrollBlock = document.querySelector(".product__media-wrapper .product_scroll_wrap");
			console.log($mediaScrollBlock)
			$mediaScrollBlock.classList.add("disable");
			//console.log($mediaScrollBlock)
			$mediaScrollBlock.addEventListener("transitionend", function(){
				$mediaScrollBlock.scrollTo(0, 0);
				// 1) 取得済みHTMLから同じIDのimgがあれば、それをそのまま写す（最も確実）
				const fromFetched = html?.getElementById(`MainVariantImage-${sectionId}`);
				if (fromFetched) {
					mainImg.src	= fromFetched.getAttribute('src');
					mainImg.alt	= fromFetched.getAttribute('alt') || mainImg.alt || '';
					if (fromFetched.width)  mainImg.width  = fromFetched.width;
					if (fromFetched.height) mainImg.height = fromFetched.height;
					setTimeout(function(){
						$mediaScrollBlock.classList.remove("disable");
					}, 100);
					return;
				}
				
				// 2) フォールバック：いま active になるはずのメディアをギャラリー内から拾う
				const targetId = `${sectionId}-${variant?.featured_media?.id}`;
				const slideImg = document
					.querySelector(`#MediaGallery-${CSS.escape(sectionId)} [data-media-id="${CSS.escape(targetId)}"] img`);
				if (slideImg?.currentSrc || slideImg?.src) {
					mainImg.src = slideImg.currentSrc || slideImg.src;
					mainImg.alt = slideImg.alt || mainImg.alt || '';
				}
				setTimeout(function(){
					$mediaScrollBlock.classList.remove("disable");
				}, 100);
			}, {
				"once": true
			})
		});
	}
}